// import history from '../../history';

import types from '../../constants';
import auth from '../../auth';

export function fetchCompany(companyId) {
  return async(dispatch) => {
    dispatch({type: types.COMPANY_LOADING_START});
    fetch(`/api/companies/${companyId}`, {
      method: 'GET',
      headers: {
        pragma: 'no-cache',
        Accept: 'application/json',
        Authorization: localStorage.token,
      },
    })
      .then((response) => {
        if (response.status === 403 || response.status === 401) {
          auth.logoutAndRedirect();
          throw new Error('Not authenticated.');
        }

        return response.json();
      })
      .then((data) => {
        dispatch({
          type: types.COMPANY_FETCH,
          payload: data.company,
        });
        dispatch({type: types.COMPANY_LOADING_END});
      });

    return true;
  };
}

export function saveCompany(company, id) {
  return async(dispatch) => {
    let url = '/api/companies';
    if (id) {
      url += `/${id}`;
    }
    const method = id ? 'PUT' : 'POST';
    
    return fetch(url, {
      method,
      body: JSON.stringify(company),
      headers: {
        pragma: 'no-cache',
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: localStorage.token,
      },
    })
      .then((response) => {
        const json = response.json();

        if (response.status === 403 || response.status === 401) {
          auth.logoutAndRedirect();
          return Promise.reject('Not authenticated.');
        }

        if (response.status !== 200) {
          return json.then(Promise.reject.bind(Promise));
        }

        return response;
      })
      .then(() => {
        dispatch({type: types.COMPANY_LOADING_END});
        // history.push('/companies');
      })
      .catch((err) => {
        let dispatchedError;
        if (err.error && err.error.type === 'validation') {
          dispatchedError = err.error.errors;
        } else {
          dispatchedError = {general: 'An internal error has occured.'};
        }

        dispatch({
          type: types.COMPANY_SET_ERROR,
          payload: dispatchedError,
        });
        dispatch({type: types.COMPANY_LOADING_END});
        throw err;
      });
  };
}

export function deleteCompany(id) {
  return async(dispatch) => {
    dispatch({type: types.COMPANY_LOADING_START});
    return fetch(`/api/companies/${id}`, {
      method: 'DELETE',
      headers: {
        pragma: 'no-cache',
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: localStorage.token,
      },
    })
      .then((response) => {
        if (response.status === 403 || response.status === 401) {
          auth.logoutAndRedirect();
          return Promise.reject('Not authenticated.');
        }

        return response;
      })
      .then(() => {
        dispatch({type: types.COMPANY_LOADING_END});
        // history.push('/companies');
      })
      .catch((err) => {
        let dispatchedError;
        if (err.error && err.error.type === 'validation') {
          dispatchedError = err.error.errors;
        } else {
          dispatchedError = {general: 'An internal error has occured.'};
        }

        dispatch({
          type: types.COMPANY_SET_ERROR,
          payload: dispatchedError,
        });
        dispatch({type: types.COMPANY_LOADING_END});
      });
  };
}

export function changeForm(field, value) {
  return async(dispatch) => {
    dispatch({
      type: types.COMPANY_CHANGE_FORM,
      payload: {field, value},
    });
  };
}

export function clearCompany() {
  return async(dispatch) => {
    dispatch({type: types.COMPANY_CLEAR});
  };
}

export function setError(err) {
  return async(dispatch) => {
    dispatch({
      type: types.COMPANY_SET_ERROR,
      payload: err,
    });
  };
}


export function setIsEdit(value) {
  return async(dispatch) => {
    dispatch({
      type: types.COMPANY_SET_IS_EDIT,
      payload: value,
    });
  };
}

export function deleteLogo(id) {
  return async(dispatch) => {
    dispatch({type: types.COMPANY_LOADING_START});
    return fetch(`/api/companies/${id}/deletecompanylogo`, {
      method: 'PUT',
      headers: {
        pragma: 'no-cache',
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: localStorage.token,
      },
    })
      .then((response) => response.json())
      .then((data) => {

        dispatch({
          type: types.COMPANY_FETCH,
          payload: data.company,
        })

        dispatch({type: types.COMPANY_LOADING_END});
      })
      .catch((err) => {
        dispatch({type: types.COMPANY_LOADING_END});
      });
  }
}

export function uploadLogo(id, logoFile) {
  return async(dispatch) => {
    dispatch({type: types.COMPANY_LOADING_START});

    let data = new FormData();
    data.append('companyLogo', logoFile);

    return fetch(`/api/companies/${id}/setcompanylogo`, {
      method: 'PUT',
      body: data,
      headers: {
        pragma: 'no-cache',
        // 'content-type': 'multipart/form-data',
        Accept: 'application/json',
        Authorization: localStorage.token,
      },
    })
      .then((response) => response.json())
      .then((data) => {

        return new Promise((resolve, reject) => {

          setTimeout(() => {
            dispatch({
              type: types.COMPANY_FETCH,
              payload: data.company,
            });
            resolve();
          }, 2000);

          dispatch({type: types.COMPANY_LOADING_END});
        });
      })
      .catch((err) => {
        dispatch({type: types.COMPANY_LOADING_END});
      });
  }
}
